<template>
<div></div>
</template>


<script>
export default {
  name: 'Minion',
  props: ["docData"],
  // components: {},

  data() { return {
    id: null,
    monsterType: '',
    maxHP: 0,
    battleId: 1,
    damageTaken: 0,
    isStunned: false,
    isMuddled: false,
    isWounded: false,
    isStrengthened: false,
    isPoisoned: false,
    isImmobilized: false,
    isElite: false,
    isInvisible: false,
    isDisarmed: false,
    isDead: false
    }
  },
  computed: {
    currentHP(){
      return this.maxHP - this.damageTaken
    },
    // isDead(){
    //   return this.maxHP >= this.currentHP
    // }

  },
  methods: {
    changeHP(amount){
      this.currentHP += amount
    },
    checkIfDead(){
      if(this.maxHP >= this.currentHP){
        isDead = true
      } else{
        return
      }
    }
  },
  watch: {
    docData (newVal, oldVal){
      Object.getOwnPropertyNames(newVal).forEach((item) => {
        this.$data[item] = newVal[item]
      })
    }
  },

  created() {
    // this.id = this.docData.doc.id
    console.log("created() triggered")
    Object.getOwnPropertyNames(this.docData).forEach((item) => {
      this.$data[item] = this.docData[item]
    })
    // let d = this.docData
    // console.log("d: ", d)
    // this.monsterType = d.monsterType
    // console.log("properties?", Object.getOwnPropertyNames(this.$data))
  },
  // mounted() {},
  // destroyed() {}
}
</script>


<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/Minion.vue